import { DelelgationModalController } from './delegation-modal.controller';
import { DelegationModalProps } from './delegation-modal.model';

export const DelegationModal = (props: DelegationModalProps) => {
  return <DelelgationModalController {...props} />;
};
